import { useState } from "react";

export function PopupChangeStore(props) {
    let acceptAction = () => {
        props.changeStore()
    }

    return (
        <div>
            <div className="head-popup">
                <div className="title">Thông báo chuyển cơ sở<span></span> </div>
            </div>
            <div className="body-popup">
              <div className="title-body">Hóa đơn sẽ được chuyển qua cơ sở <b>{props.dataStoreChange.value}</b></div>
            </div>
            <div className="bottom-popup">
            <div className="button-container">
                <div className="button-cent style3" onClick={() => {props.setShow(false); props.setDataStoreChange(null)}} >
                    <span><i className="fas fa-times" ></i></span>Hủy
                </div>
                <div className="button-cent" onClick={acceptAction}>
                    <span><i className="fas fa-save"></i></span>Xác nhận
                </div>
            </div>
            </div>
        </div>
    )
}